module.exports = __webpack_public_path__ + "media/images/steps/step_6-41b6cfa4ddd1119e469aefe385a5f66b.svg";